<script>
export default {
  name: 'LoadingItem',
};
</script>

<template>
  <div class="loading-item d-flex align-items-center i-gap-8 i-p-4">
    <div class="loading-avatar linear-background"></div>
    <div class="loading-content d-flex flex-column i-gap-2">
      <div class="loading-line linear-background"></div>
      <div class="loading-line linear-background"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.loading-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.loading-content {
  flex: 1;

  .loading-line {
    height: 10px;
    border-radius: 4px;

    &:first-child {
      width: 60%;
    }

    &:last-child {
      width: 40%;
    }
  }
}
</style>
